import Swiper from "swiper/bundle";

document.addEventListener("DOMContentLoaded", function () {

    // const imageSliderContent = new Swiper(
    //   ".section-testimonial-carousle .content-slide",
    //   {
    //     direction: "horizontal",
    //     loop: true,
    //     spaceBetween: 0,
    //     centeredSlides: true,
    //     allowTouchMove: false,
    //     autoHeight: false,
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //   }
    // );
    // // Initialize the second Swiper
    // var imageSliderImage = new Swiper(
    //   ".section-testimonial-carousle .image-slide",
    //   {
    //     direction: "horizontal",
    //     loop: true,
    //     allowTouchMove: false,
    //     preventInteractionOnTransition: true,
    //     slidesPerView: 1,
    //     // spaceBetween: 0,
    //     freeMode: false, // Snap slides into place
    //     spaceBetween: 20, // Space between slides

    //     effect: "slide",
    //     breakpoints: {
    //       1800: {
    //         slidesPerView: 3,
    //         spaceBetween: 32,
    //       },
    //       1200: {
    //         slidesPerView: 2,
    //         spaceBetween: 24,
    //         loop: true,
    //       },
    //       768: {
    //         slidesPerView: 2,
    //         spaceBetween: 15,
    //         loop: true,
    //       },
    //     },
    //   }
    // );
    // imageSliderContent.controller.control = imageSliderImage;
    // imageSliderImage.controller.control = imageSliderContent;

       var imageSliderContent = new Swiper(
         ".section-testimonial-carousle .image-slide",
         {
           spaceBetween: 10,
           slidesPerView: 1,
           allowTouchMove: false,
           //  freeMode: true,
           //  watchSlidesProgress: true,
           freeMode: false, // Disable free mode to snap slides
           centeredSlides: false, // Make sure slides aren't centered
           watchSlidesProgress: true,
           slideToClickedSlide: true,
              breakpoints: {
          1800: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
          1200: {
            slidesPerView: 2.5,
            spaceBetween: 24,
            loop: true,
          },
          850: {
            slidesPerView: 2,
            spaceBetween: 24,
            loop: true,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true,
          },
        },
         }
       );
       var imageSliderImage = new Swiper(
         ".section-testimonial-carousle .content-slide",
         {
           spaceBetween: 10,
           allowTouchMove: false,
           navigation: {
             nextEl: ".swiper-button-next",
             prevEl: ".swiper-button-prev",
           },
           thumbs: {
             swiper: imageSliderContent,
           },
         }
       );
});
